// removed by extract-text-webpack-plugin
module.exports = {"row":"bjNxXRJ-dExFfz3h1yRXM","col":"_2kI3nmyDRMzWosxlRSys06","col-md-1":"ux9BHxQwtxvGDjmzt-whQ","col-md-4":"_2UhbzH6-nrSCg2Rdl7nI4j","col-md-6":"_3_APOwLfe9ieJfm5G3mO_6","col-md-12":"jIg8sGhaPJK4kD6sXp3zU","pull-right":"_35ydbYf1Q2uRYEmNlNmNPp","pull-left":"_1LEE2QDlvCAKCOT_RIgSUB","padding8":"_1tCSau4Rl5RrjJDoMMjnuE","padding16":"_172gMUgRGF2NK1c2o34EIF","button-label":"CdAUV_H-PdUFIvNL8WFr0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserLicense/UserLicense.scss
// module id = 2678
// module chunks = 0